/*
 * Visto recientemente (snippets/cv-vistos.liquid, sections/cv-vistos-recientes.liquid,
 * sections/static-cv-vistos-recientes.liquid, templates/search.cv-vistos.liquid).
 *
 * En la página de producto registra la vista (config.current). Con sesión, la
 * lista es la del metafield celovendo.vistos (config.ids, impresa por Liquid)
 * más las vistas que el servicio aún no confirma, guardadas en
 * localStorage.cv_vistos como { c: cliente, ids: [...] } y mandadas a
 * POST /api/storefront/vistos. Sin sesión, la lista vive en
 * localStorage.cv_vistos_invitado y pasa a la cuenta al iniciar sesión (y se
 * borra del navegador). Siempre lo más reciente primero, máximo 20.
 *
 * Cada [data-cv-vistos] es un carril: si hay al menos data-min productos
 * (sin contar data-excluir), pide las tarjetas a
 * /search?view=cv-vistos&q=id:1 OR id:2 … y se muestra.
 */
(function() {
  'use strict';

  var PENDING_KEY = 'cv_vistos';
  var GUEST_KEY = 'cv_vistos_invitado';
  var MAX = 20;

  function normId(value) {
    var s = String(value == null ? '' : value).trim();
    return /^[1-9][0-9]{0,15}$/.test(s) ? s : '';
  }

  function uniqIds(list) {
    var seen = {};
    var out = [];
    (list || []).forEach(function(value) {
      var id = normId(value);
      if (id && !seen[id]) {
        seen[id] = true;
        out.push(id);
      }
    });
    return out;
  }

  // front va adelante (lo más reciente primero); sin repetidos y con tope.
  function pushFront(list, front) {
    return uniqIds((front || []).concat(list || [])).slice(0, MAX);
  }

  function readJson(key) {
    try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { return null; }
  }

  function writeJson(key, value) {
    try {
      if (value == null) localStorage.removeItem(key);
      else localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }

  // Errores después de los cuales no tiene caso reintentar lo enviado.
  var DROP_CODES = { INVALID_SIGNATURE: true, INVALID_BODY: true, INVALID_JSON: true, INVALID_IDS: true, INVALID_ACTION: true };

  function create(config) {
    var base = String(config.url || '').trim().replace(/\/+$/, '');
    var endpoint = base ? base + '/api/storefront/vistos' : '';
    var loggedIn = !!(endpoint && config.loggedIn && config.customerId && config.sig);
    var customer = loggedIn ? String(config.customerId) : '';
    var serverIds = uniqIds(config.ids);
    var pending = [];
    var guestIds = [];
    var chain = Promise.resolve();

    function current() {
      return loggedIn ? pushFront(serverIds, pending) : guestIds.slice();
    }

    function savePending() {
      writeJson(PENDING_KEY, pending.length ? { c: customer, ids: pending } : null);
    }

    function saveGuest() {
      writeJson(GUEST_KEY, guestIds.length ? { ids: guestIds } : null);
    }

    // Una petición a la vez, en orden.
    function enqueue(task) {
      var run = chain.then(task);
      chain = run.catch(function() {});
      return run;
    }

    function api(fields) {
      var body = { customerId: config.customerId, ts: config.ts, sig: config.sig };
      Object.keys(fields).forEach(function(key) { body[key] = fields[key]; });
      return fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        credentials: 'omit',
        body: JSON.stringify(body)
      }).then(function(response) {
        return response.json().catch(function() { return {}; }).then(function(json) {
          if (response.ok) return json;
          var err = new Error((json && json.error && json.error.message) || ('HTTP ' + response.status));
          err.code = (json && json.error && json.error.code) || ('HTTP_' + response.status);
          throw err;
        });
      });
    }

    // Manda las vistas pendientes. Resuelve con la lista final.
    function flush() {
      if (!loggedIn) return Promise.resolve(current());
      return enqueue(function() {
        if (!pending.length) return current();
        var sent = pending.slice();
        return api({ action: 'ver', ids: sent }).then(function(json) {
          serverIds = uniqIds(json && json.ids);
          pending = pending.filter(function(id) { return sent.indexOf(id) === -1; });
          savePending();
          return pending.length ? flush() : current();
        }, function(err) {
          if (err && DROP_CODES[err.code]) {
            pending = pending.filter(function(id) { return sent.indexOf(id) === -1; });
            savePending();
          }
          if (window.console) console.warn('[vistos] no se pudo guardar', err && err.code);
          throw err;
        });
      });
    }

    function view(value) {
      var id = normId(value);
      if (!id) return;
      if (loggedIn) {
        if (!pending.length && serverIds[0] === id) return;
        pending = pushFront(pending, [id]);
        savePending();
        flush().catch(function() {});
      } else {
        guestIds = pushFront(guestIds, [id]);
        saveGuest();
      }
    }

    function clear() {
      pending = [];
      serverIds = [];
      guestIds = [];
      savePending();
      saveGuest();
      if (!loggedIn) return Promise.resolve([]);
      return enqueue(function() {
        return api({ action: 'borrar' }).then(function(json) {
          serverIds = uniqIds(json && json.ids);
          return current();
        });
      });
    }

    // Arranque: recupera lo pendiente de este cliente y suma lo visto sin sesión.
    var merged = 0;
    var guest = readJson(GUEST_KEY);
    guestIds = uniqIds(guest && guest.ids).slice(0, MAX);
    if (loggedIn) {
      var saved = readJson(PENDING_KEY);
      if (saved && String(saved.c) === customer) pending = uniqIds(saved.ids).slice(0, MAX);
      if (guestIds.length) {
        merged = guestIds.length;
        pending = uniqIds(pending.concat(guestIds)).slice(0, MAX);
        guestIds = [];
        saveGuest();
      }
      savePending();
    }

    return {
      ids: current,
      view: view,
      flush: flush,
      clear: clear,
      merged: merged,
      loggedIn: loggedIn,
      pendingCount: function() { return pending.length; }
    };
  }

  // Ids a mostrar en un carril: sin el producto actual y con tope.
  function idsFor(all, exclude, max) {
    var skip = normId(exclude);
    return uniqIds(all).filter(function(id) { return id !== skip; }).slice(0, max || MAX);
  }

  function searchUrl(root, ids) {
    var q = ids.map(function(id) { return 'id:' + id; }).join(' OR ');
    return (root || '/search') + '?view=cv-vistos&type=product&q=' + encodeURIComponent(q);
  }

  function intAttr(el, name, fallback) {
    var n = parseInt(el.getAttribute(name), 10);
    return n > 0 ? n : fallback;
  }

  function updateArrows(section) {
    var track = section.querySelector('[data-cv-vistos-track]');
    if (!track) return;
    var prev = section.querySelector('[data-cv-vistos-prev]');
    var next = section.querySelector('[data-cv-vistos-next]');
    var maxScroll = track.scrollWidth - track.clientWidth;
    var atStart = track.scrollLeft <= 2;
    var atEnd = track.scrollLeft >= maxScroll - 2;
    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
    // Las clases deciden las flechas y el desvanecido de cada borde (cv-vistos.css).
    section.classList.toggle('cv-vistos--scrolls', maxScroll > 2);
    section.classList.toggle('cv-vistos--at-start', atStart);
    section.classList.toggle('cv-vistos--at-end', atEnd);
  }

  /*
   * Al pasar el mouse por una tarjeta con más fotos, las demás fotos del
   * producto rotan sobre la principal (snippets/cv-vistos-card.liquid las
   * manda en <script data-cv-vistos-fotos="id"> después de la tarjeta). Una capa encima
   * con una sola foto, que cambia cada PHOTO_MS desvaneciéndose y volviendo a
   * aparecer; al salir se quita y queda la foto original. Solo
   * con mouse: en pantallas táctiles no hay hover.
   */
  var PHOTO_MS = 1100;
  // Igual que la transición de .cv-vistos__foto en cv-vistos.css.
  var PHOTO_FADE_MS = 160;

  // product-item imprime un <style> tras la tarjeta: la lista se busca por id, no por posición.
  function photosFor(card) {
    var id = normId(card.getAttribute('data-product-id'));
    var node = id && card.parentNode ? card.parentNode.querySelector('script[data-cv-vistos-fotos="' + id + '"]') : null;
    if (!node) return [];
    try {
      var list = JSON.parse(node.textContent || '[]');
      if (!Array.isArray(list)) return [];
      return list.filter(function(url) { return typeof url === 'string' && /^(https:\/\/|\/)/.test(url); });
    } catch (e) {
      return [];
    }
  }

  function bindCardPhotos(card) {
    var photos = photosFor(card);
    var box = card.querySelector('.aspect-ratio');
    if (photos.length < 2 || !box) return;
    var hovering = false;
    var layer = null;
    var img = null;
    var timer = null;
    var swap = null;
    var index = 0;
    // Se muestra cuando ya cargó, para no dejar la capa vacía.
    function show(url) {
      var pre = new Image();
      pre.onload = function() {
        if (!hovering) return;
        if (!layer) {
          // Primera foto: la capa aparece ya con ella, sin fundido.
          layer = document.createElement('span');
          layer.className = 'cv-vistos__fotos';
          layer.setAttribute('aria-hidden', 'true');
          img = document.createElement('img');
          img.className = 'cv-vistos__foto is-in';
          img.alt = '';
          img.src = url;
          layer.appendChild(img);
          box.appendChild(layer);
          return;
        }
        // Una sola foto a la vez: se desvanece, cambia y vuelve. Nunca queda una encima de otra.
        img.classList.remove('is-in');
        clearTimeout(swap);
        swap = setTimeout(function() {
          if (!hovering || !img) return;
          img.src = url;
          img.classList.add('is-in');
        }, PHOTO_FADE_MS);
      };
      pre.src = url;
    }
    function next() {
      index = (index + 1) % photos.length;
      show(photos[index]);
    }
    card.addEventListener('mouseenter', function() {
      if (hovering) return;
      hovering = true;
      index = 0;
      next();
      timer = setInterval(next, PHOTO_MS);
    });
    card.addEventListener('mouseleave', function() {
      hovering = false;
      clearInterval(timer);
      clearTimeout(swap);
      timer = null;
      if (layer && layer.parentNode) layer.parentNode.removeChild(layer);
      layer = null;
      img = null;
    });
  }

  function bindPhotos(track) {
    if (typeof window.matchMedia !== 'function' || !window.matchMedia('(hover: hover)').matches) return;
    var cards = track.querySelectorAll('.product-item');
    for (var i = 0; i < cards.length; i++) bindCardPhotos(cards[i]);
  }

  /*
   * La etiqueta "en el carrito" (.cart-badge, cart-badge.js) va junto al
   * precio, abajo a la derecha, en vez de sobre la foto. cart-badge.js la
   * sigue actualizando: la busca por data-cart-badge, esté donde esté.
   */
  function moveCartBadges(track) {
    var cards = track.querySelectorAll('.product-item');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (!card.querySelector) continue;
      var badge = card.querySelector('.cart-badge');
      var prices = card.querySelector('.product-item__price-list');
      if (badge && prices && badge.parentNode !== prices) prices.appendChild(badge);
    }
  }

  // Ids de las tarjetas que ya están en el carril, en orden.
  function shownIds(track) {
    var items = track.querySelectorAll('.product-item');
    var out = [];
    for (var i = 0; i < items.length; i++) out.push(normId(items[i].getAttribute('data-product-id')));
    return out;
  }

  /*
   * Resuelve true si el carril quedó visible. Con tarjetas impresas por Liquid
   * (data-cv-vistos-ssr, solo con sesión) y la misma lista, no las vuelve a
   * pedir. Las tarjetas de carga (cv-vistos--cargando, script de
   * cv-vistos-section.liquid) se van al llenar o al ocultar el carril.
   */
  function render(store, section, root) {
    var min = intAttr(section, 'data-min', 1);
    var max = intAttr(section, 'data-max', 12);
    var ids = idsFor(store.ids(), section.getAttribute('data-excluir'), max);
    var track = section.querySelector('[data-cv-vistos-track]');
    // En el editor de temas no se oculta: muestra un aviso para poder ubicarla.
    var editor = section.hasAttribute('data-cv-vistos-editor');
    function done(shown) {
      section.hidden = !shown && !editor;
      section.classList.remove('cv-vistos--cargando');
      if (!shown && track) track.innerHTML = '';
      return shown;
    }
    if (!track || ids.length < min) return Promise.resolve(done(false));
    if (section.hasAttribute('data-cv-vistos-ssr') && shownIds(track).join(',') === ids.join(',')) {
      updateArrows(section);
      moveCartBadges(track);
      bindPhotos(track);
      return Promise.resolve(done(true));
    }
    return fetch(searchUrl(root, ids), { credentials: 'same-origin' }).then(function(response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.text();
    }).then(function(html) {
      track.innerHTML = html;
      var items = track.querySelectorAll('.product-item');
      // Orden de la tarjeta para la entrada escalonada.
      for (var i = 0; i < items.length; i++) if (items[i] && items[i].style) items[i].style.setProperty('--cv-i', i);
      var shown = items.length >= min;
      // Entrada escalonada solo si la sección no estaba ya a la vista con las mismas tarjetas.
      section.classList.toggle('cv-vistos--ready', shown && !section.hasAttribute('data-cv-vistos-ssr'));
      done(shown);
      if (shown) updateArrows(section);
      if (shown) moveCartBadges(track);
      if (shown) bindPhotos(track);
      return shown;
    }).catch(function() {
      return done(false);
    });
  }

  window.CVVistos = {
    MAX: MAX,
    normId: normId,
    uniqIds: uniqIds,
    pushFront: pushFront,
    idsFor: idsFor,
    searchUrl: searchUrl,
    photosFor: photosFor,
    moveCartBadges: moveCartBadges,
    render: render,
    create: create
  };

  var el = document.getElementById('cv-vistos-config');
  if (!el) return;
  var config;
  try { config = JSON.parse(el.textContent); } catch (e) { return; }
  if (!config) return;

  var store = create(config);
  window.CVVistos.store = store;
  if (config.current) store.view(config.current);

  function bind(section) {
    var track = section.querySelector('[data-cv-vistos-track]');
    function step(dir) {
      if (!track) return;
      track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.8, 200), behavior: 'smooth' });
    }
    var prev = section.querySelector('[data-cv-vistos-prev]');
    var next = section.querySelector('[data-cv-vistos-next]');
    if (prev) prev.addEventListener('click', function() { step(-1); });
    if (next) next.addEventListener('click', function() { step(1); });
    if (track) track.addEventListener('scroll', function() { updateArrows(section); }, { passive: true });
    var clear = section.querySelector('[data-cv-vistos-clear]');
    if (clear) clear.addEventListener('click', function() {
      store.clear().catch(function() {});
      var all = document.querySelectorAll('[data-cv-vistos]');
      for (var i = 0; i < all.length; i++) all[i].hidden = true;
    });
  }

  function setup(scope) {
    var sections = scope.querySelectorAll('[data-cv-vistos]');
    for (var i = 0; i < sections.length; i++) {
      bind(sections[i]);
      render(store, sections[i], config.searchUrl);
    }
  }

  function start() {
    setup(document);
    store.flush().catch(function() {});
    window.addEventListener('resize', function() {
      var sections = document.querySelectorAll('[data-cv-vistos]');
      for (var j = 0; j < sections.length; j++) if (!sections[j].hidden) updateArrows(sections[j]);
    });
    // Editor de temas: la sección se vuelve a dibujar al cambiar sus ajustes.
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target && event.target.querySelectorAll) setup(event.target);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
